import React, { useEffect, useState } from "react";
import axios from "axios";
import { base_url } from "../utils/axiosConfig";
import ProductCard from "./ProductCard";

const RelatedProducts = ({ currentProduct }) => {
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log("🔄 useEffect triggered with currentProduct:", currentProduct);

    // Validate currentProduct
    if (!currentProduct || !currentProduct.Category) {
      console.warn("⚠️ Invalid or missing currentProduct category, skipping related fetch.");
      setRelatedProducts([]);
      setLoading(false);
      return;
    }

    const fetchProducts = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${base_url}Products`);

        // Normalize API response
        const allProducts = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.products)
          ? res.data.products
          : [res.data].filter(Boolean);

        console.log("✅ Total products fetched:", allProducts.length);

        if (allProducts.length <= 1) {
          console.warn("⚠️ Insufficient products in database for related products.");
          setRelatedProducts([]);
          setLoading(false);
          return;
        }

        // Filter products by matching category, excluding current product
        let filtered = allProducts
          .filter((item) => item.Category === currentProduct.Category && item._id !== currentProduct._id)
          .slice(0, 5); // Limit to 5 related products from same category

        // Fallback: If no matches, show random products
        if (filtered.length === 0) {
          console.warn("⚠️ No matches for category, using fallback products.");
          filtered = allProducts
            .filter((item) => item._id !== currentProduct._id)
            .sort(() => 0.5 - Math.random()) // Random shuffle
            .slice(0, 5);
        }

        console.log("🎯 Related products found:", filtered.length, filtered);
        setRelatedProducts(filtered);
      } catch (error) {
        console.error("❌ Error fetching related products:", error);
        setError(error.response?.data?.message || "Failed to load related products.");
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [currentProduct]);

  if (loading) {
    return (
      <div className="mt-5">
        <h5 className="fw-bold mb-3">Related Products</h5>
        <div className="row g-2">
          {[...Array(5)].map((_, index) => (
            <div key={index} className="col-3">
              <div className="card">
                <div className="card-img-top bg-light" style={{ height: "200px" }} />
                <div className="card-body">
                  <div className="placeholder-glow">
                    <span className="placeholder col-6"></span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) return <div className="text-danger mt-5">{error}</div>;
  if (relatedProducts.length === 0)
    return <div className="mt-5">No related products found.</div>;

  return (
    <div className="mt-5">
      <h5 className="fw-bold mb-3">Related Products</h5>

      <div className="row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-5 g-2 mt-1">
        {relatedProducts.map((product) => (
          <ProductCard
            key={product._id}
            grid={window.innerWidth < 768 ? 6 : 3}
            data={product}
          />
        ))}
      </div>
    </div>
  );
};

export default RelatedProducts;